/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/browser'

import { Branch, BranchService, initialBranchDetail } from 'features/Branch'
import { CONTACT_TYPE } from 'types'
import { getPhoneFormatter, setValue } from 'helpers/common'
import { getBoxTitle } from 'helpers/language'
import ProductBranchSearch from '../ProductBranchSearch/ProductBranchSearch'

interface BoxItemProps {
  title: string | JSX.Element
  description?: string | JSX.Element
}

const keyClassForm = 'f-product-form'

export const BoxItem = ({ title, description }: BoxItemProps): JSX.Element => {
  return (
    <div className={`${keyClassForm}__group-text`}>
      <span className={`${keyClassForm}__title-text`}>
        {getBoxTitle(title)}
      </span>
      <span className={`${keyClassForm}__description-text`}>
        {typeof description === 'string' ? setValue(description) : description}
      </span>
    </div>
  )
}

const InfoBranch: React.FC = () => {
  const { branchId } = useParams<{ branchId: string }>()
  const { t } = useTranslation(['product', 'common', 'branch'])
  const [branchInfo, setBranchInfo] = useState<Branch>()

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      const content = await BranchService.findBranchById(branchId)
      setBranchInfo(content.data || initialBranchDetail)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  const handleEditBranch = (branch: Branch) => {
    setBranchInfo(branch)
  }

  const phoneNumber = branchInfo?.contacts.find(
    (contact) =>
      contact.type === CONTACT_TYPE.PHONE ||
      contact.type === CONTACT_TYPE.CONTACT_PHONE,
  )

  const phone = phoneNumber?.number
    ? getPhoneFormatter(phoneNumber?.number as string)
    : '-'

  const renderBranchInfo = (branchInfo: Branch) => {
    const branchInfoData = [
      { title: 'branch:id.label', description: branchInfo.code },
      { title: 'company:name.label', description: branchInfo.companyName },
      { title: 'branch:name.label', description: branchInfo.name },
      {
        title: 'branch:phone.label',
        description: phone || '',
      },
    ]
    return branchInfoData.map((info, index) => {
      if (info.title === 'branch:name.label') {
        return (
          <ProductBranchSearch
            key={index}
            id={branchInfo.id}
            description={branchInfo.name}
            branchCode={branchInfo.code}
            updateCompany={handleEditBranch}
          />
        )
      } else {
        return (
          <BoxItem
            key={index}
            title={info.title}
            description={info.description}
          />
        )
      }
    })
  }

  return (
    <div className={`${keyClassForm}__section--with-border`}>
      <div className={`${keyClassForm}__title-layout`}>
        <span className={`${keyClassForm}__title`}>
          {t('product:product.branch')}
        </span>
      </div>
      <div className={`${keyClassForm}__branch-description-layout`}>
        {branchInfo && renderBranchInfo(branchInfo)}
      </div>
    </div>
  )
}

export default InfoBranch
